import React, {Component, useEffect, useState} from 'react';
import { Link } from "react-router-dom";
import "./header.css"

interface HeaderProps {
    countryView: string;
    setCountryView: React.Dispatch<React.SetStateAction<string>>;
}

const Header: React.FC<HeaderProps> = ({ countryView, setCountryView }) => {

    const [imageSrc, setImageSrc] = useState("/images/musiciens.png");
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        updateLocation(countryView)
    }, [countryView]);


        const changeCountry = (country: string) => {
            if (country === "bremen") {
                window.location.href = "/bremen";
            } else if (country === "stanford") {
                window.location.href = "/stanford";
            } else if (country === "irvine") {
                window.location.href = "/irvine";
            } else if (country === "riga") {
                window.open("https://riga.flammarion.eu")
            }

            updateLocation(country)
        };

    const updateLocation = (country: string) => {
        if (country === "bremen") {
            setImageSrc("/images/musiciens.png");
        } else if (country === "stanford") {
            setImageSrc("/images/stanford.png");
        } else if (country === "irvine") {
            setImageSrc("/images/irvine.png");
        }
    };


    return (
        <div className="top">
            <div className="topLeft">
                <Link to={"/" + countryView}>
                    <img src={imageSrc} alt={"Logo pays"} />
                </Link>
            </div>
            <div className="topRight">
                <ul className="topList">
                    <li className="topListItem">
                        <span className="link" onClick={() => setIsOpen(!isOpen)}>
                        Lieu
                        </span>

                        {isOpen && (
                            <ul className="dropdown">
                                <li
                                    onClick={() => changeCountry("irvine")}
                                >
                                    Irvine
                                </li>

                                <li
                                    onClick={() => changeCountry("stanford")}
                                >
                                    Stanford
                                </li>

                                <li
                                    onClick={() => changeCountry("bremen")}
                                >
                                    Bremen
                                </li>
                                <li
                                    onClick={() => changeCountry("riga")}
                                >
                                    Riga
                                </li>
                            </ul>
                        )}
                    </li>
                    <li className="topListItem">
                        <Link className="link" to="/album">
                            album
                        </Link>
                    </li>
                </ul>
            </div>
        </div>
    );
}

export default Header;